<template>
  <div class="playlist-item cursor-pointer" @mouseover="thumbMouseOver()" @click.stop="playItem()" :class="{'playlist-item-playing': isCurrentMedia}">
    <!-- <template>
    <feather-icon icon="PlayIcon" :svgClasses="['h-5 w-5']" class="playlist-item-play-icon" v-if="isCurrentMedia"/>
      <span v-else class="empty-icon"></span>
    </template> -->
    <div class="playlist-image-item">
      <span class="watching" v-if="isCurrentMedia">Assistindo</span>
      <img class="playlist-thumb" :src="imageUrl" />
    </div>
    <div class="playlist-item-detail">
      <!-- <div class="flex justify-between">
        <p class="text-primary card-text-commodity">{{itemPlaylist ? itemPlaylist.subjects[0].name : ''}}</p>
        <span class="item-date">{{ itemPlaylist ? itemPlaylist.data_object : '' | moment("from") }}</span>
      </div> -->
      <p class="mr-1 bold chapeu">{{getHat}}</p>
      <div class="card-text-title card-title">{{itemPlaylist ? itemPlaylist.content.title.data : ''}}</div>
    </div>
    <div class="playlist-item-icon">
      <feather-icon v-if="!isCurrentMedia" icon="TrashIcon" :svgClasses="['h-5 w-5']" class="playlist-item-trash-icon" @click.stop="removeItem()"/>
        <!-- <span v-else class="empty-icon-trash"></span> -->
      <!-- <template>
      </template> -->
    </div>

    <!-- <span v-if="isCurrentMedia">{{$t('PLAYLIST').Running}}</span> -->
    <!-- <div v-if="isCurrentMedia"></div> -->
  </div>
</template>

<script>
import formatFieldHelper from '../../../../helpers/format-field-helper';
export default {
  props: {
    itemPlaylist: {
      required: true
    },
    currentMedia: {
      require: true
    }
  },
  data() {
    return {
      itemHover: false,
      isPlaying: false,
      imgLink: '',
      currentItem: false
    };
  },
  watch: {
    "$store.state.playlistItemSelected"(value) {
      // console.log(value);

      if (value) {
        if (this.itemPlaylist._id == value._id) {
          this.isPlaying = true;
        } else {
          this.isPlaying = false;
        }
      } else {
       this.isPlaying = false;
      }
    }
  },
  computed: {
    getHat() {
      if (this.itemPlaylist) {
        if (this.itemPlaylist.hat[0]) {
          return this.itemPlaylist.hat[0].name;
        }
      }
      return "";
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    isCurrentMedia() {
      if (!this.itemPlaylist || !this.currentMedia) return false;
      return this.itemPlaylist._id == this.currentMedia._id;
    },
    imageUrl() {
      if (this.itemPlaylist) {
        if (this.itemPlaylist.thumb) {
          return this.itemPlaylist.thumb.image_path;
        }
        if (this.itemPlaylist.image) {
          return this.itemPlaylist.image.image_path;
        }
        if (this.itemPlaylist.subjects) {
          let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
          return require(`@/assets/images/commodity/${originCode}/${this.itemPlaylist.subjects[0].code}.png`);
        }
      }
      return require("@/assets/images/informative/placeholder115.svg");
    },
    hasYoutube() {
      return !!this.itemPlaylist.youtubeId;
    }
  },
  methods: {
    thumbMouseOver() {
      this.itemHover = true;
    },
    isCurrentItemPlayer(value) {
      if (value._id == this.itemPlaylist._id) {
        this.isPlaying = true;
        this.playItem(value);
      } else {
        this.isPlaying = false;
      }

    },
    removeItem() {
      this.$store.dispatch("removeItemPlaylist", this.itemPlaylist);
    },
    playItem() {
      this.$emit('playItem', this.itemPlaylist);
    }
  },
  mounted() {
    this.imgLink = this.imageUrl;
  },
  components: {}
};
</script>

<style lang="scss">
.playlist-item {
  display: flex;
  padding: 10px 20px;

  img {
    width: 100%;
    height: 70px;
    margin-right: 5px;
    object-fit: cover;
    object-position: 0 50%;
  }

  .playlist-item-play-icon {
    margin-right: 10px;
    margin-left: -10px;
  }

  .playlist-item-trash-icon {
    margin-left: 20px;
  }

  .empty-icon-trash {
    margin-left: 40px;
  }

  .empty-icon {
    margin-left: 18px
  }

  .playlist-item-close-icon {
    margin-right: -5px !important;
    align-self: center;
  }
  .card-title {
    font-size: 12px;
  }

  .card-text-title {
    margin-bottom: 0 !important;
  }
}

.playlist-item-playing {
  background-color: #D2DCD8;
}
.theme-dark .playlist-item:hover {
  background-color: #4D5762 !important
}

.playlist-item:hover {
  background-color: #D2DCD8;
}

.playlist-item-detail {
    // max-height: 100px;
}
</style>
